import { render, staticRenderFns } from "./ExpiredIcon.vue?vue&type=template&id=ceaffb02&"
import script from "./ExpiredIcon.vue?vue&type=script&lang=ts&"
export * from "./ExpiredIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports